import React, { PureComponent, PropTypes } from 'react';
import classnames from 'classnames';
import Cell from './cell';
import RadioSelector from '../radioselector';
import { STATUS_ACTIVE, STATUS_DELETED, STATUS_HIDDEN, STATUS_MASTERED, STATUS_NONE } from '../../services/Card';

const statusChoices = [
    { state: STATUS_ACTIVE, className: 'fa fa-eye' },
    { state: STATUS_MASTERED, className: 'fa fa-graduation-cap' },
    { state: STATUS_HIDDEN, className: 'fa fa-trash-o delete' }
];

class Row extends PureComponent {
    render() {
        let { handleKeyDown, id, lastRow, onCellChange, onStateChange, state, values } = this.props;
        let props;
        let cells = values.map((value, index) => {
            props = { handleKeyDown, index, id, onCellChange, value };
            let required = !!values.join('').trim();
            return (<Cell
                key={ index }
                required={ required && index % 2 === 0 && !lastRow}
                { ...props }
            />);
        });

        let classes = classnames({
            'row': true,
            'deleted': state === STATUS_DELETED || state === STATUS_HIDDEN
        });
        return (<div className={ classes }>
            <div className="cells">{cells}</div>
            <RadioSelector options={statusChoices} selectedOption={ state } defaultOption={ STATUS_NONE } disabled={ lastRow } onSelect={ state => onStateChange(id, state) } />
        </div>);
    }
}

Row.propTypes = {
    handleKeyDown: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    lastRow: PropTypes.bool.isRequired,
    onCellChange: PropTypes.func.isRequired,
    state: PropTypes.number.isRequired,
    values: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

export default Row;


// WEBPACK FOOTER //
// ./src/components/deckeditor/row.js